export default {"src":"/_next/static/media/CopyIcon.51cecad8.svg","height":20,"width":17};